import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/use-toast';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        
        navigate('/');
        toast({
          title: 'Logged out',
          description: 'You have been successfully logged out.',
        });
      } catch (error: any) {
        toast({
          variant: 'destructive',
          title: 'Error',
          description: error.message || 'An error occurred during logout',
        });
        // If there's an error, still redirect to home
        navigate('/');
      }
    };

    handleLogout();
  }, [navigate]);

  // Show a loading indicator while logging out
  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
      <p className="text-sm text-muted-foreground">Logging out...</p>
    </div>
  );
};

export default Logout; 